export const formatAmount = (amount: string) => Number(amount.split(',').join('.'))
